import useClickOutside from "components/useClickOutSide";
import { Button, Checkbox, Color, Size, StickerPosition, Tooltip } from "@usitsdasdesign/dds-react";
import { useRef, useState } from "react";
import ActionDropBox from "./ActionDropBox";
import Icon from "atoms/Icon";

function FilterContext({ type = 'filter', title = 'Filter', menuItems = [], onItemsSelect, onShowSavedFilters, contextPosition, disableSave = false, ...rest }) {

    const [showContext, setShowContext] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setShowContext(false));

    const actionButtons = [
        {
            label: 'Close',
            kind: 'silent',
            onClick: () => setShowContext(false),
            className: '!flex md:!hidden'
        },
        {
            label: 'Done',
            kind: 'secondaryLoud',
            onClick: () => setShowContext(false),
            className: '!flex md:!hidden'
        },
    ];

    if (type === 'filter' && !disableSave) {
        actionButtons.push(
            {
                label: 'Saved Filters',
                kind: 'silent',
                onClick: onShowSavedFilters
            }
        )
    };

    const tooltipArgs = {
        invokeType: "hover",
        type: "regular",
        color: Color.dark,
        position: StickerPosition["bottom-right"],
        tooltipIndent: 5,
        tooltipShift: -4,
        width: 200,
        hasBeak: true,
        size: Size.m,
        id: "tooltipData",
        className: 'z-50'
    };

    return (
        <div className='relative'>
            <Button
                onClick={() => setShowContext(!showContext)}
                {...rest}
            />
            {
                showContext && (
                    <div ref={ref}>
                        <ActionDropBox
                            label={title}
                            onClose={() => setShowContext(false)}
                            buttons={actionButtons}
                            height="h-screen md:h-auto md:max-h-[400px]"
                            position={contextPosition}
                            disableSave={disableSave}
                        >
                            <div className="flex flex-col">
                                {
                                    menuItems.map(item => {
                                        return (
                                            <div className="flex items-center justify-between gap-2 pr-2">
                                                <Checkbox
                                                    label={item.label}
                                                    value={item.isActive}
                                                    showLabel
                                                    className="flex-1 pt-2 pb-1 px-1 hover:bg-neutral-50 !h-auto"
                                                    onChangeHandler={() => onItemsSelect(item)}
                                                    isDisabled={item?.isDisabled}
                                                />
                                                {
                                                    item?.reason && (
                                                        <Tooltip
                                                            text={item.reason}
                                                            {...tooltipArgs}
                                                        >
                                                            <Icon
                                                                icon="info__l__stroke"
                                                                size="w-4 h-4"
                                                                color="gray"
                                                            />
                                                        </Tooltip>
                                                    )
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </ActionDropBox>
                    </div>
                )
            }
        </div>
    )

}

export default FilterContext;